import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_ATTEVENT,
  DELETE_ATTEVENT,
  UPDATE_ATTEVENT,
  ADD_NEW_ATTEVENT,
} from "./actionType";

import {
  getAttEventSuccess,
  getAttEventFail,
  deleteAttEventSuccess,
  deleteAttEventFail,
  updateAttEventSuccess,
  updateAttEventFail,
  addAttEventSuccess,
  addAttEventFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveAttEventApi,
  getAttEventApi,
  updateAttEventApi,
  deleteAttEventApi,
  addNewAttEventApi
} from "../../helpers/backend_helper";

function* getAttEvent({ payload: attEvent }) {
  try {
    const response = yield call(getAttEventApi, attEvent);
    yield put(getAttEventSuccess(GET_ATTEVENT, response.data));
  } catch (error) {
    yield put(getAttEventFail(GET_ATTEVENT, error));
  }
}

function* onUpdateAttEvent({ payload: attEvent }) {
  try {
    if (attEvent.setApprove) {
      const response = yield call(approveAttEventApi, attEvent);
      yield put(updateAttEventSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateAttEventApi, attEvent);
      yield put(updateAttEventSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAttEventFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAttEvent({ payload: attEvent }) {
  try {
    const response = yield call(deleteAttEventApi, attEvent);
    yield put(deleteAttEventSuccess({ attEvent, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAttEventFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAttEvent({ payload: attEvent }) {
  try {
    const response = yield call(addNewAttEventApi, attEvent);
    yield put(addAttEventSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAttEventFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetAttEvent() {
  yield takeEvery(GET_ATTEVENT, getAttEvent);
}

export function* watchUpdateAttEvent() {
  yield takeEvery(UPDATE_ATTEVENT, onUpdateAttEvent);
}

export function* watchDeleteAttEvent() {
  yield takeEvery(DELETE_ATTEVENT, onDeleteAttEvent);
}

export function* watchAddNewAttEvent() {
  yield takeEvery(ADD_NEW_ATTEVENT, onAddNewAttEvent);
}

function* attEventSaga() {
  yield all([
    fork(watchGetAttEvent),
    fork(watchDeleteAttEvent),
    fork(watchUpdateAttEvent),
    fork(watchAddNewAttEvent)
  ]);
}

export default attEventSaga;
